import React, { useState, useEffect } from "react"
import { Box, Text, Link } from "@quarkly/widgets"
import translations from "../translations"

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [lang, setLang] = useState("en")

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent")
    if (!consent) {
      setIsVisible(true)
    }

    const savedLang = localStorage.getItem("lang")
    if (savedLang) {
      setLang(savedLang)
    }

    const syncLang = () => {
      const savedLang = localStorage.getItem("lang")
      if (savedLang) {
        setLang(savedLang)
      }
    }
    window.addEventListener("languagechange", syncLang)
    return () => window.removeEventListener("languagechange", syncLang)
  }, [])

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "true")
    setIsVisible(false)
  }

  if (!isVisible) return null

  const t = translations[lang].cookieBanner

  return (
    <Box
      position="fixed"
      bottom="0"
      left="0"
      width="100%"
      background="--color-dark"
      padding="20px 60px"
      sm-padding="16px 20px"
      display="flex"
      justify-content="space-between"
      align-items="center"
      sm-flex-direction="column"
      sm-align-items="flex-start"
      sm-grid-gap="16px"
      md-flex-direction="column"
      md-align-items="flex-start"
      md-grid-gap="16px"
      z-index="9999"
      box-shadow="0px -4px 12px rgba(0,0,0,0.1)"
    >
      <Text
        color="--color-light"
        font="normal 300 14px/1.5 --fontFamily-googleInter"
        margin="0"
        max-width="800px"
      >
        {t.text}
        <Link
          href="/privacy-policy"
          color="--color-lightD1"
          hover-color="#ffffff"
          text-decoration-line="underline"
        >
          {t.privacy}
        </Link>
        {t.and}
        <Link
          href="/terms-and-conditions"
          color="--color-lightD1"
          hover-color="#ffffff"
          text-decoration-line="underline"
        >
          {t.terms}
        </Link>
        {t.suffix}
      </Text>
      <Box
        as="button"
        onClick={acceptCookies}
        background="--color-light"
        color="--color-dark"
        padding="10px 24px"
        font="normal 500 14px/1.5 --fontFamily-googleInter"
        border="none"
        border-radius="2px"
        cursor="pointer"
        hover-background="#ffffff"
        transition="background 0.2s ease"
      >
        {t.accept}
      </Box>
    </Box>
  )
}

export default CookieBanner
